<div class="profile relative">
  <button
    type="button"
    class="py-2 px-3 font-medium text-gray-500 hover:bg-primary-dark"
    (click)="mainMenuDrawer.toggle()">
    <fa-icon [icon]="faBars"></fa-icon>
  </button>
</div>

<fc-drawer #mainMenuDrawer title="Main Menu">
  <div>
    <ng-container *ngIf="!user">
      <div class="flex gap-3">
        <button
          type="button"
          class="flex-1 rounded-md bg-primary-md-dark py-1 px-3 font-medium text-white"
          routerLink="/auth/login">
          Login
        </button>
        <button
          type="button"
          class="flex-1 rounded-md border border-primary-md-dark py-1 px-3 font-medium text-primary-md-dark"
          routerLink="/auth/register">
          Register
        </button>
      </div>
    </ng-container>
    <ng-container *ngIf="user">
      <div class="flex items-center space-x-3">
        <picture class="flex-none">
          <img
            class="h-10 w-10 rounded-full border border-primary-md-dark"
            [src]="
              user.propic_path
                ? user.propic_path
                : 'assets/images/default-user.png'
            "
            alt="profile image" />
        </picture>
        <div class="leading-5 line-clamp-1">
          <div class="font-bold line-clamp-1">{{ user.name }}</div>
          <a
            (click)="mainMenuDrawer.toggle()"
            routerLink="user/profile"
            class="flex items-center space-x-2 text-sm text-primary-md-dark">
            <span>Profile Setting</span>
            <fa-icon class="text-xs" [icon]="faAngleRight"></fa-icon>
          </a>
        </div>
      </div>
      <div
        class="shadow-black/15 mt-3 w-full rounded-lg bg-primary-main px-3 py-2 shadow-md">
        <div class="flex items-center justify-between">
          <div>
            <div class="flex items-center space-x-2">
              <fa-icon
                class="text-primary-md-dark"
                [icon]="faCreditCard"></fa-icon>
              <span>Happy Pay</span>
            </div>
            <div class="text-xs sm:text-sm">
              Account Number : {{ user.happy_pay.account_no }}
            </div>
            <div class="mt-1 font-bold">
              {{ user.happy_pay.current_balance | fcCurrency }}
            </div>
          </div>
          <button
            class="flex-none items-center rounded-md bg-primary-md-dark px-2 py-1 text-white">
            <fa-icon class="mr-1" [icon]="faSquarePlus"></fa-icon>
            Top Up
          </button>
        </div>
      </div>
      <div
        class="mt-5 flex items-center justify-between px-2 text-sm"
        *ngIf="!user.is_email_verified"
        (click)="verifyEmail(); mainMenuDrawer.toggle()">
        <div>
          <span class="font-medium">Verifikasi Email</span>
          <div class="mt-1 leading-4 text-primary-darkest/60">
            Hi, please verify your email and get a special voucher
          </div>
        </div>
        <fa-icon [icon]="faAngleRight"></fa-icon>
      </div>
    </ng-container>
    <div class="mt-5 px-2">
      <h3 class="font-semibold capitalize text-primary-md-dark">My Info</h3>
      <ul class="text-sm">
        <li>
          <a
            (click)="mainMenuDrawer.toggle()"
            routerLink="/user/dashboard"
            class="flex items-center py-2">
            <fa-icon class="basis-6" [icon]="faGauge"></fa-icon>
            <span>Dashboard</span>
          </a>
        </li>
      </ul>
      <h3 class="mt-2 font-semibold capitalize text-primary-md-dark">
        Transaction
      </h3>
      <ul class="text-sm">
        <li>
          <a
            (click)="mainMenuDrawer.toggle()"
            routerLink="/user/checkout"
            class="flex items-center py-2">
            <fa-icon class="basis-6" [icon]="faMoneyCheckDollar"></fa-icon>
            <span>Checkout</span>
          </a>
        </li>
        <li>
          <a
            (click)="mainMenuDrawer.toggle()"
            routerLink="/user/order"
            class="flex items-center py-2">
            <fa-icon class="basis-6" [icon]="faBagShopping"></fa-icon>
            <span>Order</span>
          </a>
        </li>
        <li>
          <a
            (click)="mainMenuDrawer.toggle()"
            routerLink="/user/happy-pay"
            class="flex items-center py-2">
            <fa-icon class="basis-6" [icon]="faCoins"></fa-icon>
            <span>Happy Pay</span>
          </a>
        </li>
      </ul>
      <h3 class="mt-2 font-semibold capitalize text-primary-md-dark">
        Navigation
      </h3>
      <ul class="text-sm">
        <li>
          <a
            (click)="categoryDrawer.toggle()"
            class="flex cursor-pointer items-center py-2">
            <fa-icon class="basis-6" [icon]="faLayerGroup"></fa-icon>
            <span>Category</span>
          </a>
        </li>
        <li>
          <a
            (click)="brandDrawer.toggle()"
            class="flex cursor-pointer items-center py-2">
            <fa-icon class="basis-6" [icon]="faLayerGroup"></fa-icon>
            <span>Brand</span>
          </a>
        </li>
      </ul>
      <h3 class="mt-2 font-semibold capitalize text-primary-md-dark">Other</h3>
      <ul class="text-sm">
        <li>
          <a
            (click)="mainMenuDrawer.toggle()"
            routerLink="/user/review"
            class="flex items-center py-2">
            <fa-icon class="basis-6" [icon]="faMessage"></fa-icon>
            <span>Review</span>
          </a>
        </li>
        <li>
          <a
            (click)="mainMenuDrawer.toggle()"
            routerLink="/user/beautybook-post"
            class="flex items-center py-2">
            <fa-icon class="basis-6" [icon]="faWandMagicSparkles"></fa-icon>
            <span>Beautybook Post Saya</span>
          </a>
        </li>
        <li>
          <a
            (click)="mainMenuDrawer.toggle()"
            routerLink="/user/wishlist"
            class="flex items-center py-2">
            <fa-icon class="basis-6" [icon]="faHeart"></fa-icon>
            <span>Wishlist</span>
          </a>
        </li>
      </ul>
      <h3 class="mt-2 font-semibold text-primary-md-dark">Pusat Bantuan</h3>
      <ul class="text-sm">
        <li>
          <a
            (click)="mainMenuDrawer.toggle()"
            routerLink="/about"
            class="flex items-center py-2">
            <fa-icon class="basis-6" [icon]="faBook"></fa-icon>
            <span>About Happybeauty</span>
          </a>
        </li>
        <li>
          <a
            (click)="mainMenuDrawer.toggle()"
            routerLink="/faq"
            class="flex items-center py-2">
            <fa-icon class="basis-6" [icon]="faQuestion"></fa-icon>
            <span>Help</span>
          </a>
        </li>
        <li>
          <a
            (click)="mainMenuDrawer.toggle()"
            routerLink="/term-condition"
            class="flex items-center py-2">
            <fa-icon class="basis-6" [icon]="faFileContract"></fa-icon>
            <span>Term and Condition</span>
          </a>
        </li>
        <li *ngIf="user">
          <a
            (click)="mainMenuDrawer.toggle(); logout()"
            routerLink=""
            class="flex items-center py-2">
            <fa-icon class="basis-6" [icon]="faRightFromBrcket"></fa-icon>
            <span>Logout</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</fc-drawer>

<fc-drawer #categoryDrawer title="Category">
  <ul class="overflow-y-auto" *ngIf="categories.length">
    <li *ngFor="let category1 of categories; let i = index">
      <div
        class="flex cursor-pointer items-center justify-end rounded-lg p-3 hover:bg-gray-100"
        (click)="category1.show_children = !category1.show_children">
        <button
          type="button"
          class="flex-1 items-center gap-2 text-sm"
          *ngIf="category1.children.length"
          [ngClass]="{
            'rotate-180 transform': category1.show_children == true
          }">
          <fa-icon
            [icon]="faChevronDown"
            class="rotate-180 text-gray-500"></fa-icon>
        </button>
        <span
          class="w-11/12 line-clamp-1"
          (click)="onSelectCategory(category1.slug)"
          [ngClass]="{
            'font-bold': selectedCategorySlugs.includes(category1.slug)
          }">
          {{ category1.name }}
        </span>
      </div>
      <ng-container
        *ngIf="category1.children.length && category1.show_children == true">
        <ul class="py-1 pl-4">
          <li *ngFor="let category2 of category1.children; let j = index">
            <div
              class="flex cursor-pointer items-center justify-end rounded-lg p-3 hover:bg-gray-100"
              (click)="category2.show_children = !category2.show_children">
              <button
                type="button"
                class="flex-1 items-center gap-2 text-sm"
                *ngIf="category2.children.length"
                [ngClass]="{
                  'rotate-180 transform': category2.show_children == true
                }">
                <fa-icon
                  [icon]="faChevronDown"
                  class="rotate-180 text-gray-500"></fa-icon>
              </button>
              <span
                class="w-11/12 line-clamp-1"
                [ngClass]="{
                  'font-bold': selectedCategorySlugs.includes(category2.slug)
                }"
                (click)="onSelectCategory(category1.slug, category2.slug)">
                {{ category2.name }}
              </span>
            </div>
            <ng-container
              *ngIf="
                category2.children.length && category2.show_children == true
              ">
              <ul class="py-1 pl-4">
                <li *ngFor="let category3 of category2.children; let k = index">
                  <div
                    class="flex cursor-pointer items-center justify-end rounded-lg p-3 hover:bg-gray-100"
                    (click)="
                      category3.show_children = !category3.show_children
                    ">
                    <span
                      class="w-11/12 line-clamp-1"
                      [ngClass]="{
                        'font-bold': selectedCategorySlugs.includes(
                          category3.slug
                        )
                      }"
                      (click)="
                        onSelectCategory(
                          category1.slug,
                          category2.slug,
                          category3.slug
                        )
                      ">
                      {{ category3.name }}
                    </span>
                  </div>
                </li>
              </ul>
            </ng-container>
          </li>
        </ul>
      </ng-container>
    </li>
    <p-skeleton *ngIf="!categories.length" class="h-2 w-full"></p-skeleton>
  </ul>
</fc-drawer>
<fc-drawer #brandDrawer title="Brand">
  <ul class="overflow-y-auto">
    <li
      *ngFor="let brand of brands"
      class="w-full cursor-pointer hover:bg-primary-lightest">
      <div (click)="onSelectBrand(brand.id)" class="w-full p-3 font-normal">
        {{ brand.name }}
      </div>
    </li>
  </ul>
</fc-drawer>
